// extracted by mini-css-extract-plugin
export var active = "tabButton-module--active--ecb54";
export var button = "tabButton-module--button--1e52c";
export var circle = "tabButton-module--circle--e4343";
export var disabled = "tabButton-module--disabled--f56a4";